export default __webpack_public_path__ + "static/media/Logo.7f429dc3.png";